import React, { Component } from "react";
import {
  Layout,
  Row,
  Col,
  Card,
  Divider,
  Button,
  Menu,
  notification,
  Rate,
  Input,
  Modal,
} from "antd";
import {
  EditTwoTone,
  ArrowLeftOutlined,
  FacebookOutlined,
  TwitterOutlined,
  LinkedinOutlined,
  InstagramOutlined,
  YoutubeOutlined,
  CheckCircleTwoTone,
  SearchOutlined,
  ShareAltOutlined,
  CopyOutlined,
  PlusOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { withAppContext } from "../../store/contextStore";
import NumberFormat from "react-number-format";
import { noAuthgetDetails, noAuthGetInfo, update } from "../../api/Apis";
import SendMessage from "../../common/SendMessage";
import Subscriptions from "../Subscriptions/Subscriptions";
import MyNetwork from "../../common/MyNetwork";
import Testmonials from "../../common/Testmonials";
import Advertisement from "../../common/Advertisement";
import MLShomes from "../../common/MLShomes";
import LocalHomes from "../../common/LocalHomes";
import BuyersListing from "../../common/BuyersListing";
import PortfoliosList from "../../common/PortfoliosList";
import Loading from "../../common/Loading";
import DataNotFound from "../../common/DataNotFound";
import Lenders from "./Lenders";
import Missleads from "../MissLeads/Missleads";
import Invitation from "../../common/Invitation";
import HomeBuddha from "../../common/HomeBuddha";

// ── Brand tokens ───────────────────────────────────────────────────────────────
const NAVY   = "#1A2280";
const GOLD   = "#D4921A";
const BORDER = "#E2E8F0";
const MUTED  = "#718096";
const WHITE  = "#FFFFFF";
const LIGHT  = "#F7F9FC";

class ViewProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      imageLoading: true,
      profileExperience: "",
      agentMlsId: "",
      profileName: "",
      profilePhone: "",
      profilleSpecialtyName: "",
      profilleEmail: "",
      reviewerName: "",
      reviewDate: "",
      reviewDiscription: "",
      addReviewerName: "",
      addReviewDate: "",
      addReviewDiscription: "",
      imageKeys: [],
      saveDetailsFalse: false,
      editingBio: false,
      editTestmonials: false,
      userBio: "",
      selectedProps: "updatinggg",
      setFalse: true,
      addTestmonialFalse: false,
      testmonialsList: [],
      testimonialSpinning: false,
      editTestimonial: false,
      editTestimonialIndex: "",
      countName: "false",
      profilePicture: "",
      userDetails: "",
      activeItemKey: "",
      homesList: [],
      id: "",
      buyerHomesList: [],
      menuForDesktopViewTrue: false,
      userLogin: false,
      EditIcon: false,
      dataLoading: false,
      requiredUserId: "",
      userName: "",
      tabs: {
        login: {
          V:  ["Testimonials", "Portfolio", "Subscriptions", "My Network", "Home Buddha"],
          L:  ["Testimonials", "Portfolio", "Subscriptions", "My Network", "Home Buddha"],
          AG: [
            "MLS Homes",
            "OFF MLS Homes",
            "Buyers",
            "Leads",
            "Testimonials",
            "Portfolio",
            "Subscriptions",
            "My Network",
            "Home Buddha",
          ],
          S:  ["Sell", "Buy", "Home Buddha"],
          B:  ["Sell", "Buy", "Home Buddha"],
          SB: ["Sell", "Buy", "Home Buddha"],
          HO: ["Home Buddha"],
        },
        "non-login": {
          V:  ["Testimonials", "Portfolio"],
          L:  ["Testimonials", "Portfolio"],
          AG: ["MLS Homes", "OFF MLS Homes", "Testimonials", "Portfolio", "Join My Circle"],
          S:  ["Sell", "Buy"],
          B:  ["Sell", "Buy"],
          HO: [],
        },
      },
      visibleTabs: [],
      lendersEmails: [],
      agentMlsList: [],
      enableInviteLenersPopUp: false,
      showSetupMyHome: false,
      // ── NEW ──────────────────────────────────────────────────────────────────
      referringAgent:  null,   // agent/lender who referred this buyer/seller
      showInviteModal: false,
    };
  }

  componentDidMount() {
    this.profileInit();
  }

  profileInit = async () => {
    const data12 = "";
    this.props.context.setHomeDetails(data12, "EMPTY_DATA");
    this.props.context.setBuyerHomeDetails(data12, "BUYER_EMPTY_DATA");
    const { userDetails } = this.props.context.state;
    let userDetailsId = JSON.parse(await localStorage.getItem("userDetails"));

    let validUserId =
      userDetails && userDetails.id
        ? userDetails.id
        : userDetailsId && userDetailsId.id;

    if (window.screen.width >= 1023) {
      this.setState({ menuForDesktopViewTrue: true });
    }

    let validateUsername = this.props?.match?.params?.userName || "";
    let userId = "";

    if (validateUsername !== "") {
      try {
        const checkUserApi = await noAuthGetInfo("checkUser/" + validateUsername);
        if (checkUserApi.success) {
          userId = checkUserApi.data?.[0]?.id;
        }
      } catch (error) {
        alert("Something went wrong.!");
      }
    } else {
      userId = this.props?.match?.params?.id;
    }

    let agentId = validUserId || "";
    if (agentId === userId) {
      this.getUserProfile(userId, true);
    } else {
      this.getUserProfile(userId, false);
    }
  };

  getUserProfile = async (userId, editPermissions) => {
    this.setState({ EditIcon: editPermissions, requiredUserId: userId });
    try {
      const userProfileDetails = await noAuthgetDetails("getUsers", userId);
      if (userProfileDetails.success) {
        let userType = userProfileDetails.data.userProfile;
        if (window.location.pathname === `/sellerBuyer/viewProfile/${userId}`) {
          this.setState({
            imageLoading: false,
            userDetails: userProfileDetails.data,
            agentMlsId: userProfileDetails.data.mlsId,
            agentMlsList: userProfileDetails.data.mlsSateList,
            profilePicture: userProfileDetails.data?.profilePicture2?.[0]
              ? `https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/${userProfileDetails.data.profilePicture2[0]}`
              : "",
            visibleTabs: this.state.tabs["login"]["SB"],
            activeItemKey: "Sell",
            lendersEmails: userProfileDetails.data.lenderInfo,
          });
        } else {
          this.setState({
            imageLoading: false,
            userDetails: userProfileDetails.data,
            agentMlsId: userProfileDetails.data.mlsId,
            agentMlsList: userProfileDetails.data.mlsSateList,
            profilePicture: userProfileDetails.data?.profilePicture?.[0]
              ? `https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/${userProfileDetails.data.profilePicture[0]}`
              : "",
            visibleTabs:
              this.state.tabs[editPermissions ? "login" : "non-login"][userType] || [],
            activeItemKey:
              editPermissions && userType === "AG" ? "MLS Homes"
              : userType === "HO" ? "Home Buddha"
              : userType === "V" || userType === "L" ? "Testimonials"
              : userType === "S" || userType === "B" ? "Sell"
              : "OFF MLS Homes",
            lendersEmails: userProfileDetails.data.lenderInfo,
          });
        }
        // ── NEW: load referring agent for branding ─────────────────────────
        this.loadReferringAgent(userProfileDetails.data);
      }
      this.props.context.handlePagePathname(window.location.href);
    } catch (error) {
      console.log(error.response, "error");
    }
  };

  // ── NEW: fetch referring agent/lender profile ─────────────────────────────
  loadReferringAgent = async (userData) => {
    // Don't show referring agent on agent's own profile
    if (userData.userProfile === "AG" || userData.userProfile === "L") return;
    const refId = userData.referedById || userData.referredBy
      || userData.invitedBy || userData.referredByAgent;
    if (!refId || String(refId).length < 10) return;
    try {
      const agentResp = await noAuthgetDetails("getAgents", refId);
      if (agentResp?.success && agentResp?.data) {
        this.setState({ referringAgent: agentResp.data });
        console.log("[ViewProfile] referring agent loaded:", agentResp.data.firstName);
      }
    } catch(e) { console.warn("loadReferringAgent:", e.message); }
  };

  handleMenuItems = (e) => {
    if (e.key) this.setState({ activeItemKey: e.key });
  };

  handleAddhome = async () => {
    localStorage.removeItem("buyerData", "");
    const { activeItemKey } = this.state;
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    this.props.context.setLoading(true);
    if (userDetails && userDetails.userProfile !== "AG") {
      if (activeItemKey === "Sell") {
        await this.props.history.push("/add/userHomeForm");
      } else {
        await this.props.history.push("/add/buyerform");
      }
    } else {
      if (activeItemKey === "OFF MLS Homes") {
        await this.props.history.push(`/add/sellerProfile`);
      } else {
        await this.props.history.push("/add/buyerProfile");
      }
    }
  };

  handleFavoritesCount = (favoritesData, favoritesDataLength) => {
    this.props.context.handleFavoritesCount(favoritesData, favoritesDataLength);
  };

  setLoadingfalse = () => this.setState({ dataLoadingFalse: false });
  setLoadingTrueForDeleteHomeListing = () => this.setState({ dataLoadingFalse: true });

  handleEditProfile = (e) => {
    this.setState({ setFalse: false, [e.target.name]: e.target.value });
  };

  handleBack = () => {
    const { requiredUserId } = this.state;
    const loc = this.props.location.state;
    const path = window.location.pathname;
    if (["DetailPage", "speakToBuyerAgent", "getPreApprovedForaLoan"].includes(loc)) {
      this.props.history.goBack();
    } else if (path === `/agent/viewProfile/${requiredUserId}` || loc === "Agents") {
      this.props.history.push("/agent");
    } else if (path === `/lenders/viewProfile/${requiredUserId}` || loc === "Lender") {
      this.props.history.push("/lenders");
    } else if (path === `/marketplace/viewProfile/${requiredUserId}` || loc === "Vendor") {
      this.props.history.push("/marketplace");
    } else {
      this.props.history.goBack();
    }
  };

  openInNewTab = (url) => {
    const w = window.open(url, "_blank", "noopener,noreferrer");
    if (w) w.opener = null;
  };

  copyUrl = () => {
    document.getElementById("shareProfileUrl").select();
    document.execCommand("copy");
    notification["info"]({ message: "URL copied successfully" });
  };

  handleUserName = (e) => this.setState({ [e.target.name]: e.target.value });

  checkUserName = async () => {
    if (!this.state.userName) {
      notification["error"]({ message: "Please enter username" });
      return;
    }
    const checkAvailability = await noAuthGetInfo("checkUser/" + this.state.userName);
    if (checkAvailability.data.length > 0) {
      notification["error"]({ message: "Username already exist!", description: "Try again" });
    } else {
      this.setState({ previewProfileUrl: true });
    }
  };

  updateUsername = async () => {
    this.setState({ dataLoading: true });
    const { userDetails, userName } = this.state;
    const data = { entityData: { userName } };
    const result = await update("users", userDetails.id, data);
    if (result.success) {
      this.profileInit();
      this.resetUserInfo();
      notification["success"]({ message: "Username saved successfully. Thank you." });
    } else {
      this.resetUserInfo();
      notification["error"]({ message: "Something Went Wrong", description: "Please try again" });
    }
  };

  resetUserInfo = () => {
    this.setState({ userName: "", dataLoading: false, previewProfileUrl: false, enableShareProfileUrl: false });
  };

  handleEditBio = () => this.setState({ editingBio: true, editing: true });
  handleCloseInvitationModal = () => this.setState({ enableInviteLenersPopUp: false });

  // ── NEW: Referring agent card for buyers/sellers/homeowners ─────────────────
  renderReferringAgentCard() {
    const { referringAgent } = this.state;
    if (!referringAgent) return null;

    const name = `${referringAgent.firstName || ""} ${referringAgent.lastName || ""}`.trim() || "Your Agent";
    const isLender = referringAgent.userProfile === "L";
    const photo = referringAgent.profilePicture?.[0]
      ? `https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/${referringAgent.profilePicture[0]}`
      : null;
    const company = referringAgent.newdata?.companyName || referringAgent.companyName || "";
    const phone = referringAgent.phone || "";
    const email = referringAgent.email || "";
    const agentId = referringAgent.id || "";

    const sm = referringAgent.socialMedia || {};
    const profilePath = referringAgent.userProfile === "L"
      ? `/lenders/viewProfile/${agentId}`
      : `/agent/viewProfile/${agentId}`;

    return (
      <div style={{
        background: `linear-gradient(135deg, ${NAVY} 0%, #2A3390 100%)`,
        borderRadius: "14px", marginTop: "14px", overflow: "hidden",
        boxShadow: "0 4px 20px rgba(26,34,128,0.15)",
      }}>
        <div style={{ padding: "16px 16px 14px" }}>
          {/* Label */}
          <div style={{
            fontSize: "10px", fontWeight: 700, color: "rgba(255,255,255,0.55)",
            textTransform: "uppercase", letterSpacing: ".1em", marginBottom: "10px",
          }}>
            {isLender ? "Your Lender" : "Your Agent"} · My Home Buddha
          </div>

          {/* Photo + name */}
          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
            {photo ? (
              <img src={photo} alt={name} style={{
                width: "56px", height: "56px", borderRadius: "50%",
                objectFit: "cover", border: `2px solid ${GOLD}`, flexShrink: 0,
              }} />
            ) : (
              <div style={{
                width: "56px", height: "56px", borderRadius: "50%",
                background: "rgba(212,146,26,0.2)", border: `2px solid ${GOLD}`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "22px", flexShrink: 0,
              }}>
                {isLender ? "💰" : "🏠"}
              </div>
            )}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ color: WHITE, fontWeight: 800, fontSize: "15px", lineHeight: 1.2 }}>{name}</div>
              {company && (
                <div style={{ color: "rgba(255,255,255,0.65)", fontSize: "11px", marginTop: "3px" }}>{company}</div>
              )}
            </div>
          </div>

          {/* Social icons */}
          {(sm.facebook || sm.instagram || sm.Linkedin || sm.youtube || sm.twitter || sm.website) && (
            <div style={{ display: "flex", gap: "12px", marginBottom: "12px", justifyContent: "center" }}>
              {sm.facebook  && <a href={sm.facebook}  target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.7)", fontSize: "16px" }}>f</a>}
              {sm.instagram && <a href={sm.instagram} target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.7)", fontSize: "15px" }}>ig</a>}
              {sm.Linkedin  && <a href={sm.Linkedin}  target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.7)", fontSize: "15px" }}>in</a>}
              {sm.youtube   && <a href={sm.youtube}   target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.7)", fontSize: "15px" }}>yt</a>}
              {sm.website   && <a href={sm.website}   target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.7)", fontSize: "15px" }}>🌐</a>}
            </div>
          )}

          {/* Action buttons */}
          <div style={{ display: "flex", gap: "6px", marginBottom: "8px" }}>
            {phone && (
              <a href={`tel:${phone}`} style={{
                flex: 1, textAlign: "center", background: "rgba(255,255,255,0.12)",
                border: "1px solid rgba(255,255,255,0.2)", borderRadius: "50px",
                padding: "7px 4px", color: WHITE, fontSize: "11px", fontWeight: 700, textDecoration: "none",
              }}>📞 Call</a>
            )}
            {email && (
              <a href={`mailto:${email}`} style={{
                flex: 1, textAlign: "center", background: "rgba(255,255,255,0.12)",
                border: "1px solid rgba(255,255,255,0.2)", borderRadius: "50px",
                padding: "7px 4px", color: WHITE, fontSize: "11px", fontWeight: 700, textDecoration: "none",
              }}>✉️ Email</a>
            )}
            <a href={`https://ai.myhomebuddha.com?ref=${agentId}`}
              target="_blank" rel="noopener noreferrer" style={{
                flex: 1, textAlign: "center", background: GOLD, borderRadius: "50px",
                padding: "7px 4px", color: "#2A1600", fontSize: "11px", fontWeight: 800, textDecoration: "none",
              }}>🤖 AI Tools</a>
          </div>

          {/* View Profile + Testimonials */}
          <div style={{ display: "flex", gap: "6px" }}>
            <Link to={profilePath} style={{
              flex: 1, textAlign: "center", background: "rgba(255,255,255,0.15)",
              border: "1px solid rgba(255,255,255,0.25)", borderRadius: "50px",
              padding: "7px 4px", color: WHITE, fontSize: "11px", fontWeight: 700, textDecoration: "none",
            }}>👤 View Profile</Link>
            <Link to={profilePath} onClick={() => {}} style={{
              flex: 1, textAlign: "center", background: "rgba(255,255,255,0.15)",
              border: "1px solid rgba(255,255,255,0.25)", borderRadius: "50px",
              padding: "7px 4px", color: WHITE, fontSize: "11px", fontWeight: 700, textDecoration: "none",
            }}>⭐ Testimonials</Link>
          </div>
        </div>
        {/* Gold accent bar */}
        <div style={{ height: "3px", background: `linear-gradient(90deg, ${GOLD}, #F5C842)` }} />
      </div>
    );
  }

  // ── Branded left sidebar for agents (unchanged from document) ────────────────
  renderAgentSidebar() {
    const {
      userDetails, profilePicture, EditIcon,
      enableShareProfileUrl, userName,
    } = this.state;
    const nd  = userDetails.newdata || {};
    const ap  = userDetails.agentPersonality || {};
    const sm  = userDetails.socialMedia || {};
    const initials =
      ((userDetails.firstName || "")[0] || "").toUpperCase() +
      ((userDetails.lastName  || "")[0] || "").toUpperCase();

    return (
      <>
        <div style={{
          background: `linear-gradient(135deg, ${NAVY} 0%, #2A3390 100%)`,
          borderRadius: "14px", marginBottom: "14px",
          boxShadow: "0 6px 24px rgba(26,34,128,0.18)", overflow: "hidden",
        }}>
          <div style={{ padding: "22px 20px 16px" }}>
            {EditIcon && (
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginBottom: "14px" }}>
                <Link to={`/myProfile/${userDetails.id}`}>
                  <button style={{
                    background: "rgba(255,255,255,0.15)", color: WHITE,
                    border: "1.5px solid rgba(255,255,255,0.3)", borderRadius: "50px",
                    fontSize: "12px", padding: "4px 12px", cursor: "pointer",
                  }}>✏️ Edit Profile</button>
                </Link>
                <button style={{
                  background: "rgba(255,255,255,0.15)", color: WHITE,
                  border: "1.5px solid rgba(255,255,255,0.3)", borderRadius: "50px",
                  fontSize: "12px", padding: "4px 12px", cursor: "pointer",
                }} onClick={() => this.setState({ enableShareProfileUrl: !enableShareProfileUrl })}>
                  <ShareAltOutlined /> Share
                </button>
              </div>
            )}

            {enableShareProfileUrl && (
              <div style={{
                background: "rgba(255,255,255,0.1)", borderRadius: "8px",
                padding: "12px", marginBottom: "14px",
              }}>
                {userDetails.userName ? (
                  <div style={{ display: "flex", gap: "8px" }}>
                    <Input readOnly id="shareProfileUrl"
                      value={process.env.REACT_APP_BASE_URL + userDetails.userName}
                      style={{ borderRadius: "8px", fontSize: "12px" }} />
                    <Button icon={<CopyOutlined />} onClick={this.copyUrl} type="primary" />
                  </div>
                ) : (
                  <>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <Input id="userName" name="userName" value={userName}
                        onChange={this.handleUserName} placeholder="Choose a username"
                        style={{ borderRadius: "8px", fontSize: "12px" }} />
                      <Button icon={<SearchOutlined />} onClick={this.checkUserName} type="primary" />
                    </div>
                    {userName && (
                      <div style={{ color: "rgba(255,255,255,0.7)", fontSize: "11px", marginTop: "4px" }}>
                        {process.env.REACT_APP_BASE_URL + userName}
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            <div style={{ textAlign: "center", marginBottom: "14px" }}>
              {profilePicture ? (
                <img src={profilePicture} alt="profile" style={{
                  width: "96px", height: "96px", borderRadius: "50%",
                  border: `3px solid ${GOLD}`, objectFit: "cover",
                  display: "block", margin: "0 auto 10px",
                }} />
              ) : (
                <div style={{
                  width: "96px", height: "96px", borderRadius: "50%",
                  border: `3px solid ${GOLD}`, background: "rgba(255,255,255,0.12)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  margin: "0 auto 10px", fontSize: "30px", fontWeight: 800, color: GOLD,
                }}>{initials}</div>
              )}

              {userDetails.avgRating > 0 && (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "6px", marginBottom: "6px" }}>
                  <Rate disabled defaultValue={userDetails.avgRating} style={{ fontSize: "13px", color: GOLD }} />
                  <span style={{ color: "rgba(255,255,255,0.6)", fontSize: "12px" }}>
                    ({userDetails.testimonialCount})
                  </span>
                </div>
              )}

              <h2 style={{ color: WHITE, fontSize: "20px", fontWeight: 800, margin: "0 0 2px", letterSpacing: "-0.02em" }}>
                {userDetails.firstName} {userDetails.lastName}
              </h2>

              {nd.companyName && (
                <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "12px", margin: "0 0 10px" }}>
                  {nd.companyName}
                </p>
              )}

              {userDetails.firstName !== this.props.context.state.userDetails?.firstName && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <SendMessage
                    msgButtonTitle="Contact"
                    buttonAlign="listing"
                    toName={`${userDetails.firstName} ${userDetails.lastName}`}
                    propertyTitle="" propertyImages={null}
                    mlsId={userDetails.mlsId || ""} agentEmail={userDetails.email}
                    isRegistred={true} messageType="general" isRegistredUser={true}
                  />
                </div>
              )}
            </div>

            {(sm.facebook || sm.instagram || sm.Linkedin || sm.youtube || sm.twitter || sm.website) && (
              <div style={{ display: "flex", justifyContent: "center", gap: "14px", paddingTop: "10px" }}>
                {sm.facebook  && <FacebookOutlined  style={{ color: WHITE, fontSize: "18px", cursor: "pointer" }} onClick={() => this.openInNewTab(sm.facebook)} />}
                {sm.instagram && <InstagramOutlined style={{ color: WHITE, fontSize: "18px", cursor: "pointer" }} onClick={() => this.openInNewTab(sm.instagram)} />}
                {sm.Linkedin  && <LinkedinOutlined  style={{ color: WHITE, fontSize: "18px", cursor: "pointer" }} onClick={() => this.openInNewTab(sm.Linkedin)} />}
                {sm.youtube   && <YoutubeOutlined   style={{ color: WHITE, fontSize: "18px", cursor: "pointer" }} onClick={() => this.openInNewTab(sm.youtube)} />}
                {sm.twitter   && <TwitterOutlined   style={{ color: WHITE, fontSize: "18px", cursor: "pointer" }} onClick={() => this.openInNewTab(sm.twitter)} />}
                {sm.website   && <GlobalOutlined    style={{ color: WHITE, fontSize: "18px", cursor: "pointer" }} onClick={() => this.openInNewTab(sm.website)} />}
              </div>
            )}
          </div>
          <div style={{ height: "4px", background: `linear-gradient(90deg, ${GOLD}, #F5C842)` }} />
        </div>

        <div style={{
          background: WHITE, borderRadius: "12px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
          marginBottom: "12px", overflow: "hidden",
        }}>
          {[
            userDetails.email    && ["✉️ Email",    userDetails.email],
            userDetails.phone    && ["📞 Phone",    <a href={`tel:${userDetails.phone}`} style={{ color: NAVY }}><NumberFormat format="(###) ###-####" value={userDetails.phone} displayType="text" /></a>],
            nd.website           && ["🌐 Website",  <a href={nd.website} target="_blank" rel="noopener noreferrer" style={{ color: NAVY }}>{nd.website.replace(/^https?:\/\//, "")}</a>],
            nd.companyAddress    && ["📍 Address",  nd.companyAddress],
            nd.language          && ["🗣 Languages", nd.language],
            userDetails.mlsId    && ["🏷 MLS ID",   userDetails.mlsId],
            userDetails.licenseIds && ["📋 License(s)", userDetails.licenseIds],
            ap.experience        && ["⭐ Experience", ap.experience],
          ].filter(Boolean).map(([label, value], i, arr) => (
            <div key={i} style={{ padding: "10px 16px", borderBottom: i < arr.length - 1 ? `1px solid ${BORDER}` : "none" }}>
              <div style={{ fontSize: "11px", fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: ".04em", marginBottom: "2px" }}>{label}</div>
              <div style={{ fontSize: "13px", color: "#1A202C", fontWeight: 500 }}>{value}</div>
            </div>
          ))}

          {nd.Specialties?.length > 0 && (
            <div style={{ padding: "10px 16px", borderTop: `1px solid ${BORDER}` }}>
              <div style={{ fontSize: "11px", fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: ".04em", marginBottom: "6px" }}>Specialties</div>
              <div>
                {nd.Specialties.map(s => (
                  <span key={s} style={{ display: "inline-block", padding: "3px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, margin: "2px", background: `${NAVY}12`, color: NAVY, border: `1px solid ${NAVY}25` }}>{s}</span>
                ))}
              </div>
            </div>
          )}

          {nd.serviceAreas?.length > 0 && userDetails.userProfile !== "B" && (
            <div style={{ padding: "10px 16px", borderTop: `1px solid ${BORDER}` }}>
              <div style={{ fontSize: "11px", fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: ".04em", marginBottom: "4px" }}>Local Expert In</div>
              <div style={{ fontSize: "13px", color: "#2D3748", lineHeight: 1.6 }}>
                {nd.serviceAreas.map((a, i) => (
                  <span key={i}>{typeof a === "object" ? `${a.cityName} ${a.stateName}` : a}{i < nd.serviceAreas.length - 1 ? " · " : ""}</span>
                ))}
              </div>
            </div>
          )}
        </div>

        {!EditIcon && (
          <div style={{ background: `linear-gradient(135deg, #0F1560 0%, ${NAVY} 100%)`, borderRadius: "12px", padding: "18px", marginBottom: "12px" }}>
            <div style={{ fontSize: "22px", marginBottom: "6px" }}>🤖</div>
            <div style={{ color: WHITE, fontWeight: 800, fontSize: "14px", marginBottom: "6px" }}>AI-Powered Home Tools</div>
            <div style={{ color: "rgba(255,255,255,0.72)", fontSize: "12px", marginBottom: "14px", lineHeight: 1.5 }}>
              Get free home reports and personalized insights — powered by {userDetails.firstName}'s local expertise.
            </div>
            <a href={"https://ai.myhomebuddha.com?" + new URLSearchParams({ ref: userDetails.id || "", type: "AG", agentName: ((userDetails.firstName || "") + " " + (userDetails.lastName || "")).trim(), agentPhoto: (userDetails.profilePicture && userDetails.profilePicture[0]) || "", profileUrl: userDetails.profileUrl || "" }).toString()}
              target="_blank" rel="noopener noreferrer"
              style={{ display: "block", textAlign: "center", background: GOLD, color: "#2A1600", borderRadius: "50px", padding: "8px 0", fontWeight: 700, fontSize: "13px", marginBottom: "8px", textDecoration: "none" }}>
              🚀 Create Free Account
            </a>
            <a href="https://ai.myhomebuddha.com" target="_blank" rel="noopener noreferrer"
              style={{ display: "block", textAlign: "center", background: "rgba(255,255,255,0.1)", color: WHITE, border: "1.5px solid rgba(255,255,255,0.25)", borderRadius: "50px", padding: "7px 0", fontWeight: 600, fontSize: "12px", textDecoration: "none" }}>
              Explore AI Tools
            </a>
            <p style={{ color: "rgba(255,255,255,0.45)", fontSize: "10px", textAlign: "center", marginTop: "8px", marginBottom: 0 }}>
              Your account will be linked to {userDetails.firstName} automatically
            </p>
          </div>
        )}

        {(ap.unique_angle || ap.hobbies?.length || ap.origin_story || ap.fun_fact || ap.local_love) && (
          <div style={{ background: WHITE, borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.07)", marginBottom: "12px", overflow: "hidden" }}>
            <div style={{ background: `linear-gradient(90deg, ${NAVY}08, transparent)`, padding: "10px 16px", borderBottom: `2px solid ${GOLD}` }}>
              <div style={{ fontSize: "12px", fontWeight: 800, color: NAVY, textTransform: "uppercase", letterSpacing: ".05em" }}>About {userDetails.firstName}</div>
            </div>
            {ap.unique_angle && <div style={{ padding: "12px 16px", borderBottom: `1px solid ${BORDER}` }}><div style={{ fontSize: "11px", fontWeight: 700, color: GOLD, textTransform: "uppercase", letterSpacing: ".04em", marginBottom: "4px" }}>My Edge</div><div style={{ fontSize: "13px", color: "#2D3748", lineHeight: 1.6 }}>{ap.unique_angle}</div></div>}
            {ap.origin_story && <div style={{ padding: "12px 16px", borderBottom: `1px solid ${BORDER}` }}><div style={{ fontSize: "11px", fontWeight: 700, color: GOLD, textTransform: "uppercase", letterSpacing: ".04em", marginBottom: "4px" }}>My Story</div><div style={{ fontSize: "13px", color: "#2D3748", lineHeight: 1.6 }}>{ap.origin_story}</div></div>}
            {ap.local_love && <div style={{ padding: "12px 16px", borderBottom: `1px solid ${BORDER}` }}><div style={{ fontSize: "11px", fontWeight: 700, color: GOLD, textTransform: "uppercase", letterSpacing: ".04em", marginBottom: "4px" }}>Why I Love This Area</div><div style={{ fontSize: "13px", color: "#2D3748", lineHeight: 1.6 }}>{ap.local_love}</div></div>}
            {ap.fun_fact && <div style={{ padding: "12px 16px", borderBottom: ap.hobbies?.length ? `1px solid ${BORDER}` : "none" }}><div style={{ fontSize: "11px", fontWeight: 700, color: GOLD, textTransform: "uppercase", letterSpacing: ".04em", marginBottom: "4px" }}>Fun Fact</div><div style={{ fontSize: "13px", color: "#2D3748", lineHeight: 1.6 }}>{ap.fun_fact}</div></div>}
            {ap.hobbies?.length > 0 && <div style={{ padding: "12px 16px" }}><div style={{ fontSize: "11px", fontWeight: 700, color: GOLD, textTransform: "uppercase", letterSpacing: ".04em", marginBottom: "6px" }}>Outside the Office</div><div>{ap.hobbies.map(h => <span key={h} style={{ display: "inline-block", padding: "3px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, margin: "2px", background: `${GOLD}18`, color: "#7A5010", border: `1px solid ${GOLD}40` }}>{h}</span>)}</div></div>}
          </div>
        )}

        <div>
          <Advertisement otherAds={false} adType="Square" adWhereToShow="MarketPlace" adLimit="10" zipCode="" />
        </div>
      </>
    );
  }

  showBioData = () => {
    const { editing, userDetails } = this.state;
    return (
      <>
        {!editing && (
          <Card bordered={false} style={{ marginTop: "3vw" }}>
            <Row>
              <Col span={12}><span className="profile-view-name">Bio</span></Col>
              <Col span={2} offset={10} style={{ cursor: "pointer" }}>
                {window.location.pathname === "viewProfile" && (
                  <Link to={`/myProfile/${userDetails && userDetails.id}`}>
                    <EditTwoTone style={{ fontSize: "28px" }} />
                  </Link>
                )}
              </Col>
            </Row>
            <Divider style={{ backgroundColor: "#41455534" }} />
            <Col>
              <span className="bio-text">
                <div dangerouslySetInnerHTML={{ __html: userDetails.userBio || "" }} />
              </span>
            </Col>
          </Card>
        )}
      </>
    );
  };

  render() {
    const {
      activeItemKey, menuForDesktopViewTrue, EditIcon, profilePicture,
      userDetails, imageLoading, agentMlsId, enableShareProfileUrl,
      userName, previewProfileUrl, dataLoading, requiredUserId,
      lendersEmails, agentMlsList, enableInviteLenersPopUp,
    } = this.state;

    const isAgent = userDetails?.userProfile === "AG";
    const hasUserNameParam = this.props?.match?.params?.userName;

    const specialties = (
      <div style={{ textAlign: "left" }}>
        {userDetails?.newdata?.Specialties && typeof userDetails.newdata.Specialties === "object" &&
          userDetails.newdata.Specialties.map((o, index) => (
            <span key={index}>{o}{userDetails.newdata.Specialties.length - 1 !== index && ", "}</span>
          ))}
      </div>
    );

    const inviteLender = (
      <div>
        <Button type="primary" onClick={() => this.setState({ enableInviteLenersPopUp: true })}>Invite Lender</Button>
      </div>
    );

    return (
      <div style={{ backgroundColor: "#F9FAFF" }}>
        <Row className="margin-body-agent">
          <Col>
            <Button type="text" icon={hasUserNameParam ? "" : <ArrowLeftOutlined />}
              className="font-family-style font-medium-size"
              onClick={this.handleBack}
              style={{ marginTop: "1vw", marginBottom: "1vw" }}>
              {!hasUserNameParam && (
                window.location.pathname === `/agent/viewProfile/${requiredUserId}` || this.props.location.state === "Agents" ? "Back to agent search"
                : window.location.pathname === `/lenders/viewProfile/${requiredUserId}` || this.props.location.state === "Lender" ? "Back to lenders search"
                : window.location.pathname === `/marketplace/viewProfile/${requiredUserId}` || this.props.location.state === "Vendor" ? "Back to marketplace search"
                : ["DetailPage", "speakToBuyerAgent", "getPreApprovedForaLoan"].includes(this.props.location.state) ? "Back to detail page"
                : "Return to search result"
              )}
            </Button>
          </Col>
        </Row>

        <Layout className="margin-body-agent" style={{ backgroundColor: "#F9FAFF" }}>
          <Row>
            {/* ── LEFT SIDEBAR ──────────────────────────────────────────── */}
            <Col
              xl={{ span: 6, offset: 0 }} lg={{ span: 6, offset: 0 }}
              md={{ span: 22, offset: 1 }} sm={{ span: 22, offset: 1 }} xs={{ span: 22, offset: 1 }}
              style={{ marginBottom: "2vw" }}>

              <Loading enableLoading={imageLoading} />

              {userDetails && (
                <>
                  {isAgent
                    ? this.renderAgentSidebar()
                    : (
                      <>
                        {/* ── Original sidebar for non-agents ──────────── */}
                        <Card bordered={false} bodyStyle={{ padding: "5px" }}>
                          <Row justify="end">
                            {EditIcon && (
                              <Col style={{ cursor: "pointer" }}>
                                <Link to={`/myProfile/${userDetails.id}`}>
                                  <EditTwoTone style={{ fontSize: "28px", padding: "10px" }} />
                                </Link>
                              </Col>
                            )}
                          </Row>
                          <Row style={{ padding: "1%", display: "block", textAlign: "center" }}>
                            <Col>
                              {!profilePicture ? (
                                <Button shape="circle" style={{ backgroundColor: "#d4d8f1fa", width: "100px", height: "100px", borderRadius: "50px" }}>
                                  <span style={{ fontSize: "30px" }}>{userDetails.firstName?.charAt(0).toUpperCase()}</span>
                                </Button>
                              ) : (
                                <img src={profilePicture} style={{ backgroundColor: "#d4d8f1fa", width: "100px", height: "100px", borderRadius: "50px" }} alt="profile" />
                              )}
                            </Col>
                          </Row>
                          {userDetails.avgRating > 0 && (
                            <Row justify="center">
                              <Rate disabled defaultValue={userDetails.avgRating} />
                              <span style={{ marginTop: "7px" }}>({userDetails.testimonialCount})</span>
                            </Row>
                          )}
                          <Row style={{ display: "block" }}>
                            <Col style={{ marginTop: "1vw" }}>
                              <p className="profile-view-name" style={{ textAlign: "center" }}>
                                {userDetails.firstName} {userDetails.lastName}
                              </p>
                            </Col>
                            {userDetails.userProfile !== "B" && (
                              <Col>
                                <p className="profile-company-name" style={{ textAlign: "center", marginBottom: "0" }}>
                                  {userDetails.newdata?.companyName}
                                </p>
                              </Col>
                            )}
                          </Row>
                          <Row style={{ marginTop: "0.5vw" }}>
                            <Col xl={23} lg={23} md={23} sm={23} xs={23} className="profile-details">
                              <Row><span style={{ color: "gray" }}>Email : </span></Row>
                              <Row><span>{userDetails.email}</span></Row>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={23} lg={23} md={23} sm={23} xs={23} className="profile-details">
                              <Row><span style={{ color: "gray" }}>Phone : </span></Row>
                              <Row>
                                <a href={userDetails.phone && "tel:" + userDetails.phone} style={{ color: "black" }}>
                                  <NumberFormat format="(###) ###-####" value={userDetails.phone} displayType="text" />
                                </a>
                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={24}>
                              <Advertisement otherAds={false} adType="Square" adWhereToShow="MarketPlace" adLimit="10" zipCode="" />
                            </Col>
                          </Row>
                          {userDetails.newdata?.serviceAreas?.length > 0 && userDetails.userProfile !== "B" && (
                            <Row>
                              <Col xl={23} lg={23} md={23} sm={23} xs={23} className="profile-details">
                                <Row><span style={{ color: "gray" }}>I am a local expert in these towns:</span></Row>
                                <Row>
                                  <span>
                                    {userDetails.newdata.serviceAreas.map((city, index) => (
                                      <span key={index}>
                                        {typeof city === "object" && `${city.cityName} ${city.stateName}`}
                                        {typeof city === "object" && index < userDetails.newdata.serviceAreas.length - 1 ? ", " : ""}
                                      </span>
                                    ))}
                                  </span>
                                </Row>
                              </Col>
                            </Row>
                          )}
                          {userDetails.socialMedia && (
                            <>
                              <Divider />
                              <Col span={24} className="profile-details">
                                <Row>
                                  {userDetails.socialMedia.facebook  && <Col span={3}><FacebookOutlined  onClick={() => this.openInNewTab(userDetails.socialMedia.facebook)}  style={{ fontSize: "22px", cursor: "pointer" }} /></Col>}
                                  {userDetails.socialMedia.twitter   && <Col span={3}><TwitterOutlined   onClick={() => this.openInNewTab(userDetails.socialMedia.twitter)}   style={{ fontSize: "22px", cursor: "pointer" }} /></Col>}
                                  {userDetails.socialMedia.Linkedin  && <Col span={3}><LinkedinOutlined  onClick={() => this.openInNewTab(userDetails.socialMedia.Linkedin)}  style={{ fontSize: "22px", cursor: "pointer" }} /></Col>}
                                  {userDetails.socialMedia.instagram && <Col span={3}><InstagramOutlined onClick={() => this.openInNewTab(userDetails.socialMedia.instagram)} style={{ fontSize: "22px", cursor: "pointer" }} /></Col>}
                                  {userDetails.socialMedia.youtube   && <Col span={3}><YoutubeOutlined   onClick={() => this.openInNewTab(userDetails.socialMedia.youtube)}   style={{ fontSize: "22px", cursor: "pointer" }} /></Col>}
                                </Row>
                              </Col>
                            </>
                          )}
                        </Card>

                        {/* ── NEW: Referring agent card below profile ───── */}
                        {this.renderReferringAgentCard()}
                      </>
                    )
                  }

                  {isAgent && this.showBioData()}
                </>
              )}
            </Col>

            {/* ── RIGHT CONTENT ─────────────────────────────────────────── */}
            <Col
              xl={{ span: 17, offset: 0 }} lg={{ span: 17, offset: 0 }}
              md={{ span: 22, offset: 1 }} sm={{ span: 22, offset: 1 }} xs={{ span: 22, offset: 1 }}
              className="margin-left-agent">

              <div style={{ marginBottom: "2vw" }}>
                <Card className="homes-card" bordered={false} style={{ borderRadius: 10 }}>
                  <Menu
                    mode={menuForDesktopViewTrue ? "horizontal" : "inline"}
                    defaultSelectedKeys={activeItemKey}
                    onClick={this.handleMenuItems}>
                    {this.state.visibleTabs.map(tab => (
                      <Menu.Item key={tab} className={activeItemKey === tab ? "menu-items1" : "menu-items2"}>
                        {tab}
                      </Menu.Item>
                    ))}
                  </Menu>
                </Card>

                <Layout>
                  {(activeItemKey === "MLS Homes" || activeItemKey === "OFF MLS Homes" || activeItemKey === "Sell" || activeItemKey === "Buyers" || activeItemKey === "Buy") && (
                    <Card bordered={false} className="profile-details-mobile-view">
                      <Row>
                        <Col xl={12} lg={12} md={12} sm={12} xs={12} className="homes-clsname">
                          <span>{activeItemKey}</span>
                        </Col>
                        <Col xl={{ span: 3, offset: 9 }} lg={{ span: 3, offset: 9 }} md={{ span: 4, offset: 8 }} sm={{ span: 4, offset: 8 }} xs={{ span: 10, offset: 2 }} className="homes-clsname">
                          {EditIcon && !(activeItemKey === "MLS Homes") && (
                            <Button icon={<PlusOutlined style={{ color: "#FFF" }} />} className="home-add-btn" onClick={this.handleAddhome}>
                              <span className="home-text">
                                {activeItemKey === "OFF MLS Homes" || activeItemKey === "Sell" ? "Home" : "Buyer"}
                              </span>
                            </Button>
                          )}
                        </Col>
                      </Row>
                      <Divider />
                    </Card>
                  )}

                  <Row>
                    <Card bordered={false} className="profile-details-mobile-view">
                      <Row>
                        {activeItemKey === "MLS Homes" && (
                          <Col span={24} className="homeSearch" style={{ background: "white", marginTop: "-1vw" }}>
                            <MLShomes authenticate setLoadingfalse={this.setLoadingfalse} handleFavoritesCount={this.handleFavoritesCount} />
                          </Col>
                        )}
                        {(activeItemKey === "OFF MLS Homes" || activeItemKey === "Sell") && (
                          <Col span={24} className="homeSearch" style={{ background: "white", marginTop: "-1vw" }}>
                            <LocalHomes authenticate setLoadingfalse={this.setLoadingfalse} handleFavoritesCount={this.handleFavoritesCount} agentMLSId={agentMlsId} agentMlsList={agentMlsList} agentProfilePicture={profilePicture} agentProfileName={`${userDetails.firstName} ${userDetails.lastName}`} sharingUserParamsId={requiredUserId} onlyHomes={EditIcon} />
                          </Col>
                        )}
                        {(activeItemKey === "Buyers" || activeItemKey === "Buy") && (
                          <Col span={24} className="homeSearch" style={{ background: "white", marginTop: "-1vw" }}>
                            <BuyersListing authenticate setLoadingfalse={this.setLoadingfalse} handleFavoritesCount={this.handleFavoritesCount} setLoadingTrueForDeleteHomeListing={this.setLoadingTrueForDeleteHomeListing} sharingUserParamsId={requiredUserId} />
                          </Col>
                        )}
                        {activeItemKey === "Testimonials" && (
                          <Col span={24} className="homeSearch" style={{ background: "white", marginTop: "-1vw" }}>
                            <Testmonials userId={requiredUserId || userDetails.id} setLoadingfalse={this.setLoadingfalse} />
                          </Col>
                        )}
                        {activeItemKey === "Portfolio" && (
                          <Col span={24} className="homeSearch" style={{ background: "white", marginTop: "-1vw" }}>
                            <PortfoliosList portFolioTabDisabled={isAgent ? "portFolioTabDisabled" : "open"} sharingUserParamsId={requiredUserId} />
                          </Col>
                        )}
                        {activeItemKey === "Subscriptions" && (
                          <Col span={24} className="homeSearch" style={{ background: "white", marginTop: "-1vw" }}>
                            <Subscriptions setLoadingfalse={this.setLoadingfalse} />
                          </Col>
                        )}
                        {activeItemKey === "Leads" && (
                          <Col span={24} className="homeSearch" style={{ background: "white", marginTop: "-1vw" }}>
                            <Missleads />
                          </Col>
                        )}
                        {activeItemKey === "My Network" && (
                          <Col span={24} className="homeSearch" style={{ background: "white", marginTop: "-1vw" }}>
                            <MyNetwork />
                          </Col>
                        )}
                        {activeItemKey === "Home Buddha" && (
                          <Col span={24} className="homeSearch" style={{ background: "white", marginTop: "-1vw" }}>
                            {/* Only show Set Up My Home for non-agent users (agents use the buttons inside HomeBuddha) */}
                            {EditIcon && userDetails?.userProfile !== "AG" && userDetails?.userProfile !== "L" && (
                              <div style={{ padding: "12px 16px 0" }}>
                                <Button type="primary" icon={<PlusOutlined />}
                                  onClick={() => this.setState({ showSetupMyHome: true })}
                                  style={{ borderRadius: "50px", background: NAVY, border: "none", fontWeight: 700, marginBottom: "8px" }}>
                                  🏡 Set Up My Home
                                </Button>
                              </div>
                            )}
                            <HomeBuddha
                              showSetupModal={this.state.showSetupMyHome}
                              onCloseSetupModal={() => this.setState({ showSetupMyHome: false })}
                              onShowSetupModal={() => this.setState({ showSetupMyHome: true })}
                            />
                          </Col>
                        )}
                        {activeItemKey === "Join My Circle" && (
                          <Col span={24} style={{ background: "white", padding: "16px" }}>
                            <div style={{ background: "linear-gradient(135deg, #0F1560 0%, #1A2280 100%)", borderRadius: "16px", padding: "40px 32px", textAlign: "center" }}>
                              <div style={{ fontSize: "44px", marginBottom: "12px" }}>🏡</div>
                              <h2 style={{ color: "#FFFFFF", fontWeight: 800, fontSize: "24px", marginBottom: "8px", letterSpacing: "-0.02em" }}>
                                Join {userDetails.firstName}'s Real Estate Inner Circle
                              </h2>
                              <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "15px", maxWidth: "480px", margin: "0 auto 28px", lineHeight: 1.7 }}>
                                Create a free account to get access to all our AI tools, home search, sell tools, and stay connected with {userDetails.firstName} — your local real estate expert.
                              </p>
                              <div style={{ display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap", marginBottom: "28px" }}>
                                {["🤖 AI Home Reports", "🔍 Smart Home Search", "📊 Market Insights", "💬 Direct Agent Access", "🏷 Off-MLS Listings", "📱 Free Mobile App"].map(feature => (
                                  <span key={feature} style={{ background: "rgba(255,255,255,0.12)", color: "#FFFFFF", border: "1px solid rgba(255,255,255,0.25)", borderRadius: "50px", padding: "6px 14px", fontSize: "13px", fontWeight: 600 }}>{feature}</span>
                                ))}
                              </div>
                              <a href={"https://ai.myhomebuddha.com?" + new URLSearchParams({ ref: userDetails.id || "", type: "AG", agentName: ((userDetails.firstName || "") + " " + (userDetails.lastName || "")).trim(), agentPhoto: (userDetails.profilePicture && userDetails.profilePicture[0]) || "", profileUrl: userDetails.profileUrl || "" }).toString()}
                                target="_blank" rel="noopener noreferrer"
                                style={{ display: "inline-block", background: "#D4921A", color: "#2A1600", borderRadius: "50px", padding: "14px 40px", fontWeight: 800, fontSize: "16px", textDecoration: "none", marginBottom: "12px", boxShadow: "0 4px 20px rgba(212,146,26,0.4)" }}>
                                🚀 Create Free Account — It's Free
                              </a>
                              <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "12px", marginTop: "12px", marginBottom: 0 }}>
                                No credit card required · Your account will be linked to {userDetails.firstName} automatically
                              </p>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </Card>
                  </Row>
                </Layout>
              </div>

              {isAgent && (
                <>
                  <Divider />
                  <Col span={24} style={{ background: "white", marginBottom: "2vw" }}>
                    <Card className="homes-clsname" bordered={false}
                      extra={EditIcon && lendersEmails?.length < 2 && inviteLender}
                      title="My Preferred Lender(s)" style={{ padding: "0px" }} />
                  </Col>
                  <Col span={24} style={{ background: "white", marginBottom: "2vw" }}>
                    {lendersEmails?.length > 0
                      ? <Lenders showOnlyLenderCards={true} lendersEmailsList={lendersEmails} ViewProfileSpinLoading />
                      : <div style={{ padding: "4vw" }}><DataNotFound type="lenders" title="No lenders added as yet." /></div>
                    }
                  </Col>
                </>
              )}
            </Col>
          </Row>
        </Layout>

        {/* Username confirm modal */}
        <Modal centered className="modal-black-close"
          visible={previewProfileUrl} title={null} closable={false}
          afterClose={this.resetUserInfo} onCancel={this.resetUserInfo}
          footer={[
            <Button size="large" type="primary" loading={dataLoading} onClick={this.updateUsername}>Proceed</Button>,
            <Button size="large" type="default" onClick={this.resetUserInfo}>Cancel</Button>,
          ]}>
          <div style={{ padding: "40px" }}>
            <h1 style={{ color: "green", textAlign: "center" }}>
              <CheckCircleTwoTone style={{ fontSize: "120px", color: "green", textAlign: "center" }} />
              <br />{userName + " is available!"}
            </h1>
            <h2 style={{ textAlign: "center" }}>Please confirm to proceed</h2>
            <div style={{ backgroundColor: "#f0f0f0" }}>
              <Row style={{ padding: "20px" }}>
                <Input prefix={<SearchOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                  readOnly id="previewProfileUrl"
                  value={process.env.REACT_APP_BASE_URL + userName}
                  style={{ cursor: "not-allowed" }} />
              </Row>
            </div>
          </div>
        </Modal>

        {enableInviteLenersPopUp && (
          <Invitation
            enableInvitationModal={enableInviteLenersPopUp}
            handleCloseInvitationModal={this.handleCloseInvitationModal}
            invitationTitle="Lendor"
          />
        )}
      </div>
    );
  }
}

export default withAppContext(withRouter(ViewProfile));